import { useEffect, useState } from "react";
import { clearSession } from "../shared/_helpers/session";
import { useNavigate } from "react-router-dom";
import { getNotifications, removeNotification } from "../shared/_services/common.services";
import moment from 'moment';
import { useSnackbar } from "notistack";
import StarsIcon from "../styles/StarsIcon";
import { Button, Dialog, DialogContent, DialogTitle, cn } from "./ui";

const Notifications = ({ onClose, showModal }) => {
  const [notification, setNotification] = useState([]);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(false);
  }

  const getNotificationData = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const userId = currentUser?.user?._id
    const data = await getNotifications(userId);
    if (data.status === 200) {
      setNotification([...data?.data?.data]);
    }
    else {
      if (data?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("Your session has been expired!", {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'top' },
        });
        navigate('/login');
      }
    }
  }

  useEffect(() => {
    getNotificationData();
  }, []);

  const handleNavigate = async (type,data) => {
    if (type === "Appointment Reschedule Request") {
      navigate('/meetings');
    }
    if (type === "New Client Registration") {
      navigate('/users');
    }
    if(data){
      await removeNotification(data?._id,data?.type,data?.userId?._id);
      getNotificationData();
    }
    handleClose();
  }

  
  return (
    <Dialog
      open={showModal}
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
    >
      <DialogContent
        aria-describedby={undefined}
        className="tw-max-h-screen tw-overflow-y-auto"
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
          <DialogTitle>Notifications</DialogTitle>
          <Button
            variant="icon"
            size="sm"
            iconOnly
            aria-label="Close"
            className="tw-shrink-0"
            onClick={handleClose}
          >
            <StarsIcon name="x" className="tw-h-4 tw-w-4 tw-shrink-0" />
          </Button>
        </div>

        <div className="tw-grid tw-gap-3">
          {notification.length > 0 ? (
            notification.map((data, index) => {
              const currentDate = moment(data?.createdAt).format('YYYY-MM-DD');
              const previousDate = index > 0 ? moment(notification[index - 1]?.createdAt).format('YYYY-MM-DD') : null;
              const navigates = data?.type === "Appointment Reschedule Request" || data?.type === "New Client Registration";

              return (
                <div
                  onClick={() => handleNavigate(data?.type, data)}
                  key={data._id}
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNavigate(data?.type, data); } }}
                  {...(navigates && {
                    title: `Click to navigate to ${data?.type === "Appointment Reschedule Request" ? "meetings" : "client registration"} page`
                  })}
                  className={cn(
                    "tw-grid tw-gap-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-focus-ring",
                    navigates ? "tw-cursor-pointer" : "tw-cursor-default",
                  )}
                >

                  {currentDate !== previousDate && (
                    <p className="tw-m-0 tw-mt-2 tw-text-sm tw-font-semibold tw-text-text-muted">{moment(data?.createdAt).format('dddd MMM Do YYYY')}</p>
                  )}
                  <div className="tw-rounded-md tw-bg-surface-sunken tw-p-3">
                    <p className="tw-m-0 tw-text-sm tw-font-semibold tw-text-text">
                      {data?.description}
                    </p>
                    <p className="tw-mb-0 tw-mt-1 tw-text-right tw-text-xs tw-text-text-muted">{moment(data?.createdAt).format('LT')}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <h2 className="tw-m-0 tw-text-lg tw-font-bold tw-text-text">No Data Found</h2>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Notifications;
